import { render, staticRenderFns } from "./TaskViewInfoPopup.vue?vue&type=template&id=0f83e93e&scoped=true&lang=pug&"
import script from "./TaskViewInfoPopup.vue?vue&type=script&lang=js&"
export * from "./TaskViewInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskViewInfoPopup.vue?vue&type=style&index=0&id=0f83e93e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f83e93e",
  null
  
)

export default component.exports